import React, { useState } from "react";
import { contactEmail, contactNumber } from "../../utils/constants";
import { contactUsTime } from "../../utils/constants/env.constants";
import { faqList } from "../../utils/constants/ContactPage";
import { MdEmail, MdPhone, MdVerified } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import Footer from "../common/Footer";

// !! PAGE GENERATED USING AI
// Section wrapper: gradient border + inner surface
const SectionPanel = ({ gradientClass = "", children }) => {
  return (
    <div className={`rounded-3xl p-[1px] ${gradientClass}`}>
      <div className="rounded-3xl border border-white/10 bg-[#0A0D14]/75">
        {children}
      </div>
    </div>
  );
};

// Card: subtle gradient fill (no plain black), compact on mobile
const Card = ({ children, tone = "indigo" }) => {
  const toneBg =
    tone === "indigo"
      ? "from-indigo-500/10 via-fuchsia-500/5 to-cyan-500/10"
      : tone === "emerald"
      ? "from-emerald-500/10 via-teal-500/5 to-cyan-500/10"
      : tone === "sunset"
      ? "from-amber-500/10 via-rose-500/5 to-fuchsia-500/10"
      : "from-white/5 via-white/0 to-white/5";

  return (
    <div
      className={`rounded-2xl border border-white/10 bg-gradient-to-br ${toneBg}`}
    >
      <div className="rounded-2xl bg-black/25">{children}</div>
    </div>
  );
};

const ContactUs = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const toggleFaq = (idx) => setOpenFaq(openFaq === idx ? null : idx);

  return (
    <section className="min-h-screen bg-[#070A0F] text-white font-lexend">
      {/* Ambient background */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-transparent" />
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-indigo-500/12 blur-3xl" />
        <div className="absolute top-20 right-[-140px] h-[560px] w-[560px] rounded-full bg-fuchsia-500/10 blur-3xl" />
        <div className="absolute bottom-[-200px] left-[-140px] h-[620px] w-[620px] rounded-full bg-cyan-500/10 blur-3xl" />
      </div>

      {/* Top bar */}
      {/* <div className="border-b border-white/10 bg-gradient-to-r from-indigo-500/15 via-fuchsia-500/10 to-cyan-500/10">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 sm:py-4 lg:px-8">
          <p className="text-sm text-white/75">
            Support hours:{" "}
            <span className="font-semibold text-white">{contactUsTime}</span>
          </p>

          <div className="hidden lg:flex lg:items-center lg:gap-2">
            <a
              href={`tel:${contactNumber}`}
              className="rounded-lg bg-white px-4 py-2 text-sm font-semibold text-black hover:bg-white/90"
            >
              Call
            </a>
            <a
              href={`mailto:${contactEmail}`}
              className="rounded-lg border border-white/15 bg-white/5 px-4 py-2 text-sm font-semibold text-white hover:bg-white/10"
            >
              Email
            </a>
          </div>
        </div>
      </div> */}

      {/* HERO + CONTACT merged (single section) */}
      <header className="mx-auto max-w-7xl px-4 pt-8 sm:px-6 sm:pt-10 lg:px-8">
        <SectionPanel gradientClass="bg-gradient-to-br from-purple-500 via-fuchsia-500/18 to-purple-500/22">
          <div className="px-4 py-8 sm:px-10 sm:py-14">
            <div className="mx-auto max-w-4xl text-center">
              <p className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/25 px-4 py-2 text-xs font-semibold text-white/85">
                Seekho • Official Customer Support
              </p>

              <h1 className="mt-5 text-3xl font-bold tracking-tight sm:text-5xl">
                Contact Support
              </h1>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:justify-center">
                <a
                  href={`tel:${contactNumber}`}
                  className="rounded-xl flex items-center gap-x-2 bg-white px-6 py-3 text-sm font-semibold text-black hover:bg-white/90"
                >
                  <span className="flex items-center gap-x-1">
                    <MdPhone className="text-[18px]" />
                    Call
                  </span>
                  {contactNumber}
                </a>
                <a
                  href={`mailto:${contactEmail}`}
                  className="rounded-xl flex items-center gap-x-2 border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold text-white hover:bg-white/10"
                >
                  <span className="flex items-center gap-x-1">
                    <MdEmail className="text-[18px]" />
                    Email
                  </span>{" "}
                  {contactEmail}
                </a>
              </div>

              {/* <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
                Choose the fastest channel for your query.
              </p> */}
            </div>

            {/* Contact cards inside hero (no duplicate section) */}
            <div className="mt-8 grid grid-cols-1 gap-3 sm:mt-10 sm:grid-cols-3 sm:gap-4">
              <Card tone="indigo">
                <div className="p-4 sm:p-5">
                  <p className="text-xs font-semibold text-white/70">Phone</p>
                  <a
                    href={`tel:${contactNumber}`}
                    className="mt-1 block text-base font-semibold text-white hover:underline"
                  >
                    {contactNumber}
                  </a>
                  <p className="mt-1 text-xs text-white/60">{contactUsTime}</p>
                </div>
              </Card>

              <Card tone="emerald">
                <div className="p-4 sm:p-5">
                  <p className="text-xs font-semibold text-white/70">Email</p>
                  <a
                    href={`mailto:${contactEmail}`}
                    className="mt-1 block text-base font-semibold text-white hover:underline"
                  >
                    {contactEmail}
                  </a>
                  <p className="mt-1 text-xs text-white/60">
                    Best for screenshots & details
                  </p>
                </div>
              </Card>

              <Card tone="sunset">
                <div className="p-4 sm:p-5">
                  <p className="text-xs font-semibold text-white/70">
                    Languages
                  </p>
                  <p className="mt-1 text-base font-semibold text-white">
                    Hindi • English
                  </p>
                  <p className="mt-1 text-xs text-white/60 opacity-0">
                    Hindi • English
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </SectionPanel>
      </header>

      {/* MAIN */}
      <main className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* Left rail */}
          <aside className="lg:col-span-4 space-y-6">
            {/* Company */}
            <SectionPanel gradientClass="bg-gradient-to-br from-amber-500/25 via-rose-500/15 to-fuchsia-500/25">
              <div className="p-4 sm:p-6">
                <h2 className="text-base font-semibold">Company</h2>
                <div className="mt-2">
                  <Card tone="sunset">
                    <div className="p-4 sm:p-5 text-sm text-white/80">
                      <p className="font-semibold text-white">
                        Keyaro Edutech Private Limited
                      </p>
                      <p className="mt-1 text-white/75">Bengaluru, India</p>
                    </div>
                  </Card>
                </div>
              </div>
            </SectionPanel>

            {/* Trust */}
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-1">
              {[
                {
                  title: "Official channels",
                  desc: "Phone & email listed here",
                  icon: <MdVerified />,
                },
                {
                  title: "Nationwide",
                  desc: "Support across India",
                  icon: <BiSupport />,
                },
                {
                  title: "Secure help",
                  desc: "We never ask OTP",
                  icon: <AiOutlineSafetyCertificate />,
                },
              ].map((t) => (
                <Card key={t.title} tone="neutral">
                  <div className="p-4 sm:p-5">
                    <div className="text-xl">{t.icon}</div>
                    <div className="mt-2 text-sm font-semibold">{t.title}</div>
                    <div className="mt-1 text-xs text-white/65">{t.desc}</div>
                  </div>
                </Card>
              ))}
            </div>
          </aside>

          {/* Right content */}
          <section className="lg:col-span-8 space-y-6">
            {/* Services */}
            {/* <SectionPanel gradientClass="bg-gradient-to-br from-green-500/50 via-teal-500/14 to-cyan-500/20">
              <div className="p-4 sm:p-6">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
                  <div>
                    <h2 className="text-base font-semibold">
                      What we can help with
                    </h2>
                    <p className="mt-1 text-sm text-white/70">
                      Common support topics handled by our team.
                    </p>
                  </div>
                  <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/25 px-3 py-1 text-xs text-white/75">
                    Response depends on queue
                  </span>
                </div>

                <ul className="mt-4 grid grid-cols-1 gap-3 sm:mt-5 sm:grid-cols-2">
                  {(customerServices || []).map((item) => (
                    <li key={item}>
                      <Card tone="emerald">
                        <div className="p-3 sm:p-4">
                          <p className="text-sm text-white/85">{item}</p>
                        </div>
                      </Card>
                    </li>
                  ))}
                </ul>

                <div className="mt-5">
                  <Card tone="emerald">
                    <div className="p-4 sm:p-5">
                      <p className="text-sm font-semibold text-white">
                        Faster resolution
                      </p>
                      <p className="mt-1 text-sm text-white/75">
                        Share your registered number/email and payment/order ID
                        (if applicable). Add screenshots for technical issues.
                      </p>
                    </div>
                  </Card>
                </div>
              </div>
            </SectionPanel> */}

            {/* FAQ */}
            <SectionPanel gradientClass="bg-gradient-to-br from-blue-400 via-purple-500/14 to-rose-500/20">
              <div className="p-4 sm:p-6">
                <h2 className="text-base font-semibold">
                  Frequently asked questions
                </h2>
                <p className="mt-1 text-sm text-white/70">
                  Click a question to expand.
                </p>

                <div className="mt-4 divide-y divide-white/10 sm:mt-5">
                  {(faqList || []).map((item, idx) => {
                    const isOpen = openFaq === idx;
                    return (
                      <div key={item?.question || idx} className="py-3 sm:py-4">
                        <button
                          type="button"
                          onClick={() => toggleFaq(idx)}
                          className="flex w-full items-start justify-between gap-4 text-left"
                          aria-expanded={isOpen}
                        >
                          <span className="text-sm font-semibold text-white">
                            {item?.question}
                          </span>
                          <span className="mt-0.5 inline-flex h-7 w-7 items-center justify-center rounded-full border border-white/15 bg-black/20 text-white/85">
                            {isOpen ? "−" : "+"}
                          </span>
                        </button>

                        {isOpen ? (
                          <div className="mt-2">
                            <Card tone="indigo">
                              <div className="p-3 sm:p-4">
                                <p className="text-sm leading-relaxed text-white/75">
                                  {item?.answer}
                                </p>
                              </div>
                            </Card>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>

                {/* <div className="mt-5 flex flex-col gap-3 sm:mt-6 sm:flex-row">
                  <a
                    href={`tel:${contactNumber}`}
                    className="rounded-xl bg-white px-5 py-3 text-center text-sm font-semibold text-black hover:bg-white/90"
                  >
                    Call support
                  </a>
                  <a
                    href={`mailto:${contactEmail}`}
                    className="rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-center text-sm font-semibold text-white hover:bg-white/10"
                  >
                    Email support
                  </a>
                </div> */}
              </div>
            </SectionPanel>
          </section>
        </div>
      </main>

      <Footer />
    </section>
  );
};

export default ContactUs;
